import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import { components } from 'react-select'
import { PopoverModal } from 'components/UI'
// theme
import MemberPermissions from 'components/FormElements/components/MultiValueLabel/Security/components/MemberPermissions'
// types
import { MultiValueLabelProps } from 'components/FormElements/components/MultiValueLabel'

const Wrapper = styled.div`
  &:hover {
    font-weight: 500;
  }
`

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'top' as const,
    horizontal: 'center' as const
  },
  transformOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'center' as const
  },
  PaperProps: {
    style: {
      borderRadius: 3
    }
  }
}

const SecurityMultiValueLabel: React.FC<MultiValueLabelProps> = (props) => {
  const onMouseDown = (e: React.MouseEvent) => e.stopPropagation()

  return (
    <PopoverModal
      {...MODAL_PROPS}
      disableRestoreFocus
      onMouseDown={onMouseDown}
      trigger={
        <Wrapper onMouseDown={onMouseDown}>
          <components.MultiValueLabel {...props} />
        </Wrapper>
      }>
      {({ closePopup }) => (
        <MemberPermissions closePopup={closePopup} fieldValue={props.data} selectProps={props.selectProps} />
      )}
    </PopoverModal>
  )
}

export default SecurityMultiValueLabel
